<div class="root-container">
  <canvas #canvas class="canvas"></canvas>
  @if (image_preview()){
    <img class="image-preview" [src]="image_preview()">
  }
  @if(!video_stream() && hasPermission()) {
    <div class="cam-loader">
      <p>Loading camera</p>
      <spinner color="white"  />
    </div>
  }
  @if (!hasCapture() && hasPermission() && video_stream()) {
    <div class="camera">
      <video #video
            [srcObject]="video_stream()"
            [autoplay]="true"
            playsinline
            width="480"
            height="360">Video stream not available.</video>
    </div>
    <div class="mt-3 text-center">
      <select [(ngModel)]="video_source">
        @for (source of video_devices();track source.deviceId){
          <option [value]="source.deviceId"> {{ source.label }} </option>
        }
      </select>
    </div>
  }
  @if (!hasPermission()){
    <div class="request-permission">
      <div>Camera Permission denied</div>
      <div>Please allow site to access camera and try again</div>
      <a class="manual-link" href="" target="_blank">View Manual</a>
      <div (click)="reload()" class="manual-link" href="" target="_blank"></div>
      <button-component (click)="reload()" type="primary" text="Retry" bi_icon="bi-arrow-clockwise" />
    </div>
  }
</div>
